export default __webpack_public_path__ + "static/media/europe.58c93a73.jpg";